import React from 'react';
import EditUserInfoPage from './EditUserInfoPage';

const index = () => {
    return <EditUserInfoPage />;
};

export default index;
